(function () {
  'use strict';

  var containerSelector = '.js-b4b-size-chips';
  var cardSelector = '.product-item';
  var updateTimer = null;

  function getVariantIdFromValue(value) {
    if (!value || value.indexOf('variant=') === -1) {
      return null;
    }

    try {
      var url = new URL(value, window.location.origin);
      return url.searchParams.get('variant');
    } catch (error) {
      var match = value.match(/[?&]variant=(\d+)/);
      return match ? match[1] : null;
    }
  }

  function getCardVariantId(card) {
    if (!card) {
      return null;
    }

    /*
      B4B may add the variant parameter to any one of the links
      inside the product card, so inspect every relevant link.
    */
    var links = card.querySelectorAll('a[href*="variant="]');

    for (var i = 0; i < links.length; i += 1) {
      var linkVariantId = getVariantIdFromValue(
        links[i].getAttribute('href')
      );

      if (linkVariantId) {
        return linkVariantId;
      }
    }

    /*
      Also check Stiletto quick-view attributes in case B4B updates
      those instead of, or before, the visible links.
    */
    var productUrlElements = card.querySelectorAll(
      '[data-product-url*="variant="]'
    );

    for (var j = 0; j < productUrlElements.length; j += 1) {
      var attributeVariantId = getVariantIdFromValue(
        productUrlElements[j].getAttribute('data-product-url')
      );

      if (attributeVariantId) {
        return attributeVariantId;
      }
    }

    return null;
  }

  function readVariants(container) {
    if (container.b4bVariants) {
      return container.b4bVariants;
    }

    var jsonElement = container.querySelector('.js-b4b-variant-data');

    if (!jsonElement) {
      return [];
    }

    try {
      container.b4bVariants = JSON.parse(jsonElement.textContent);
      return container.b4bVariants;
    } catch (error) {
      console.warn('Caramel size chips: variant data could not be read.', error);
      return [];
    }
  }

  function setChipAvailability(chip, isAvailable) {
    chip.classList.toggle(
      'product-chips-options__item--unavailable',
      !isAvailable
    );

    if (isAvailable) {
      chip.style.removeProperty('opacity');
      chip.style.removeProperty('text-decoration');
      chip.removeAttribute('aria-label');
      chip.removeAttribute('aria-disabled');
    } else {
      chip.style.opacity = '0.45';
      chip.style.textDecoration = 'line-through';
      chip.setAttribute(
        'aria-label',
        chip.textContent.trim() + ' unavailable'
      );
      chip.setAttribute('aria-disabled', 'true');
    }
  }

  function updateSizeContainer(container) {
    var card = container.closest(cardSelector);

    if (!card) {
      return false;
    }

    var selectedVariantId = getCardVariantId(card);

    /*
      Do not guess the colour. Wait until B4B has added its
      colour-specific variant parameter.
    */
    if (!selectedVariantId) {
      return false;
    }

    var variants = readVariants(container);

    if (!variants.length) {
      return false;
    }

    var selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(selectedVariantId);
    });

    if (!selectedVariant) {
      return false;
    }

    var sizePosition = Number(
      container.getAttribute('data-size-option-position')
    );

    var colourPosition = Number(
      container.getAttribute('data-colour-option-position')
    );

    if (!sizePosition) {
      return false;
    }

    var selectedColour = colourPosition
      ? selectedVariant['option' + colourPosition]
      : null;

    var chips = container.querySelectorAll('.js-b4b-size-chip');

    chips.forEach(function (chip) {
      var sizeValue = chip.getAttribute('data-size-value');

      var isAvailable = variants.some(function (variant) {
        var sizeMatches =
          variant['option' + sizePosition] === sizeValue;

        var colourMatches =
          !colourPosition ||
          variant['option' + colourPosition] === selectedColour;

        return sizeMatches && colourMatches && variant.available === true;
      });

      setChipAvailability(chip, isAvailable);
    });

    container.setAttribute('data-b4b-size-chips-ready', 'true');

    return true;
  }

  function updateAllSizeChips() {
    document.querySelectorAll(containerSelector).forEach(function (container) {
      updateSizeContainer(container);
    });
  }

  function scheduleUpdate() {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(function () {
      updateAllSizeChips();
    }, 50);
  }

  function start() {
    updateAllSizeChips();

    /*
      B4B can alter the product links after Shopify has rendered
      the collection page. Watch for those URL changes.
    */
    var observer = new MutationObserver(function (mutations) {
      var relevantChange = mutations.some(function (mutation) {
        return (
          mutation.type === 'childList' ||
          mutation.attributeName === 'href' ||
          mutation.attributeName === 'data-product-url'
        );
      });

      if (relevantChange) {
        scheduleUpdate();
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href', 'data-product-url']
    });

    /*
      Extra checks cover slower app loading, filtering and sorting.
    */
    window.setTimeout(updateAllSizeChips, 250);
    window.setTimeout(updateAllSizeChips, 750);
    window.setTimeout(updateAllSizeChips, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();